import Config from './config.json';
import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import { Amplify, Auth } from 'aws-amplify';
import axios from 'axios';
const stage = 'prod';

export const config = () => {
    var params = {
        Auth: {
            mandatorySignId: true,
            identityPoolId: Config.prodUserPool.identityPoolId,
            region: Config.prodUserPool.REGION,
            userPoolId: Config.prodUserPool.USER_POOL_ID,
            userPoolWebClientId: Config.prodUserPool.APP_CLIENT_ID
        },
    };
    Amplify.configure(params)
    var baseUrl = Config.prodUserPool
    localStorage.setItem('baseUrl', JSON.stringify(baseUrl));
}

export const register = async (reg) => {
    var signUpParams = {
        username: reg.email.toLowerCase(),
        password: 'tirefax1234',
        attributes: {
            name: `${reg.firstName || ' '} ${reg.lastName || ''}`,
            given_name: reg.firstName || '',
            family_name: reg.lastName || '',
            phone_number: reg.phone_number || '',
            // "custom:orgId": reg.orgId,
            // "custom:roleId": reg.roleId

        }
    }

    console.log(signUpParams);

    return Auth.signUp(signUpParams)
        .then(user => {
            console.log(user)
            return user;
        })
        .catch(error => {
            console.log(error)
            throw error.code;
        })
}

const signout = () => {
    Auth.signOut({ global: true })
        .then(result => {
            localStorage.removeItem('tirefaxUserDetails');

        })
        .catch(err => console.log(err));
}

export const login = (inputs, session) => {
    var { username, password, newPassword } = inputs;
    if (newPassword.length > 0) {
        return Auth.completeNewPassword(session, newPassword, { phone_number: "+12345678900" })
            .then(async (session) => {
                await Auth.signOut();
                return session;
            })
            .catch(err => {
                console.log(err);
                return err;
            });

    } else {

        username = username.trim().toLowerCase();
        return Auth.signIn({
            username,
            password
        })
            .then(async session => {
                var role = await fetchUserRole(session);
                if (session.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    return session;
                }
                return sessionUsrUpdate(session, Config[`${stage}UserPool`])
                    .then(usrSession => {
                        return { ...usrSession.usrUpdate, role: role };
                    })
                    .catch(err => {
                        return 'logged Out';
                    })
            })
            .catch(err => {
                return err;
            })
    }

}

export function updateSessions() {
    return Auth.currentAuthenticatedUser()
        .then(async session => {
            var role = await fetchUserRole(session);
            return sessionUsrUpdate(session, Config[`${stage}UserPool`], role)
                .then(usrSession => {
                    return usrSession.usrUpdate;
                })
                .catch(err => {
                    return 'logged Out';
                })
        })
        .catch(err => {
            console.log(err);
            signout()
            return 'logged Out';
        })
}


// export function updateSessions(es, env) {
//     cognitoConfig(env);
//     return Auth.currentAuthenticatedUser()
//         .then(session => {
//             return sessionUsrUpdate(session, env, es, Config[`${env}UserPool`])
//                 .then(usrSession => {
//                     return usrSession.usrUpdate;
//                 })
//                 .catch(err => {
//                     return 'logged Out';
//                 })
//         })
//         .catch(err => {
//             return 'logged Out';
//         })
// }

export const getToken = async (cognito) => {
    const poolData = { UserPoolId: cognito.USER_POOL_ID, ClientId: cognito.APP_CLIENT_ID };
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser !== null) {
        return cognitoUser.getSession((err, session) => {
            if (session.isValid()) {
                var idToken = session.idToken.jwtToken;
                var accessToken = session.accessToken.jwtToken;
                return { idToken: idToken, accessToken: accessToken };
            } else {
                return 'logged Out';
            }
        })
    } else {
        return 'logged Out';
    }
}


export const getCurrentToken = async (session) => {
    var clientId = Config[`${stage}UserPool`].APP_CLIENT_ID;
    var poolId = Config[`${stage}UserPool`].USER_POOL_ID
    const poolData = { UserPoolId: poolId, ClientId: clientId };
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    const cognitoUser = userPool.getCurrentUser(session);
    if (cognitoUser !== null) {
        return cognitoUser.getSession((err, session) => {
            if (session.isValid()) {
                var idToken = session.idToken.jwtToken;
                var accessToken = session.accessToken.jwtToken;
                return { idToken: idToken, accessToken: accessToken };
            } else {
                return 'logged Out';
            }
        })
    } else {
        return 'logged Out';
    }
}

export const fetchUserRole = async (session) => {
    const url = 'https://d1958obtuqe4bs.cloudfront.net/users/_search';
    const body = {

        "query": {
            "bool": {
                "must": [
                    {
                        "match": { "id.keyword": session.attributes.sub }
                    }
                ]
            }
        }

    }

    return axios.post(url, body)
        .then((response) => {
            if (response?.data?.hits?.hits[0]?._source.role) {
                return response.data.hits.hits[0]._source.role;
            } else {
                return {}
            }

        })
        .catch(err => console.log(err));


}

export const sessionUsrUpdate = async (session, stage, role) => {
    console.log(await fetchUserRole(session));
    return getCurrentToken(session)
        .then(token => {
            if (token !== 'logged Out') {
                var usrUpdate = {
                    isAuthenticated: true,
                    id: session.attributes.sub,
                    firstName: session.attributes.given_name,
                    lastName: session.attributes.family_name,
                    email: session.attributes.email,
                    phone: session.attributes.phone_number,
                    stage: stage,
                    role: role,
                    userPoolId: session.pool.userPoolId,
                    userType: Config.userType,
                    idToken: token.idToken,
                    accessToken: token.accessToken
                }
                switch (Config.userType) {
                    default:
                        localStorage.setItem('tirefaxUserDetails', JSON.stringify(usrUpdate));
                        return { usrUpdate: usrUpdate }
                        break;
                }
            }
        })
        .catch(err => console.log(err))

}

export const cognitoConfig = (stage) => {
    switch (stage) {
        default:
            break
    }
}

